module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-check-d6900849.svg";